import Component from '../../lib/component'
import Scroller from '../../lib/scroller'

export default class QueryFiltersComponent extends Component {
    static selector () {
        return '.query-filters'
    }

    constructor (opts) {
        super(opts)

        this.addFeaturesToClassName()

        this.paramsQueryString = this.getQueryStringParams()
        this.params = this.getQueryStringParamsWithDefaults()

        this.render()
        this.listen()
    }

    listen () {
        this.getControlsGroupsInputs()
            .forEach(el => el
                .addEventListener('change', this.onChange.bind(this)))

        this.getControlsGroupsInputs()
            .filter(el => !el.type.match(/(radio|checkbox)/))
            .forEach(el => el
                .addEventListener('keyup', this.onChange.bind(this)))

        this.getControlsGroupsApplyBtns()
            .forEach((el) => el.addEventListener('click',
                this.onControlsGroupsApplyBtnsClick.bind(this)))

        this.getControlsGroupsClearBtns()
            .forEach((el) => {
                el.addEventListener('click',
                    this.onControlsGroupsClearBtnsClick.bind(this))

                if (el.getAttribute('role') === 'button'
                        && !el.getAttribute('tabindex'))
                    el.setAttribute('tabindex', 0)

                if (el.getAttribute('role') === 'button')
                    el.addEventListener('keydown', e =>
                        e.keyCode === 32
                                || (e.key || e.keyIdentifier || '')
                                    .match(/^(enter)$/i)
                            ? this.onControlsGroupsClearBtnsClick(e)
                            : null)
            })

        this.getControlsOffCanvasContent()
            .forEach(el => {
                el.Scroller = (new Scroller({ el: el }))
                el.Scroller.state
                    .on('update', () => this.onControlsOffCanvasContentScroll(el))
            })

        this.getControlsOffCanvasExpandToggles()
            .forEach(el => {
                el.addEventListener('click',
                    this.onControlsOffCanvasExpandToggleClick.bind(this))

                if (el.getAttribute('role') === 'button')
                    el.addEventListener('keydown', (e) =>
                        e.keyCode === 32
                                || (e.key || e.keyIdentifier || '')
                                    .match(/^(enter)$/i)
                            ? this.onControlsOffCanvasExpandToggleClick(e)
                            : null)
            })

        this.on('resize', this.onResize.bind(this))
    }

    onChange (e) {
        if (!e.target.name)
            return

        const controls = this.getControls()
            .filter(el => el.contains(e.target))[0]

        const submitBtn = this.getSubmitButtons()
            .filter(el => controls.contains(el))[0]

        if (submitBtn) {
            const isControlsChange = this.isChange(controls)

            const isInvalid = Array.from(controls
                .querySelectorAll('input, textarea, select'))
                .filter(el => el.type !== 'hidden'
                    && !el.disabled
                    && (el.pattern
                        || el.required))
                .filter(el => !el.validity.valid).length

            if (isControlsChange
                    && !isInvalid
                    && submitBtn.disabled)
                submitBtn.disabled = false

            if ((!isControlsChange
                        || isInvalid)
                    && !submitBtn.disabled)
                submitBtn.disabled = true
        }

        this.renderControlsGroupsCtaBtns()
    }

    onResize () {
        this.getControlsGroups()
            .forEach(el => {
                const groupHeader = el
                    .querySelector('.query-filters-controls-group-header')

                const groupCta = el
                    .querySelector('.query-filters-controls-group-cta')

                if (!groupHeader || !groupCta)
                    return

                const padR = `${groupCta.clientWidth + 20}px`

                if (!groupHeader
                        || groupHeader.style.paddingLeft === padR)
                    return

                groupHeader.style.paddingRight = padR
            })
    }

    onControlsGroupsApplyBtnsClick (e) {
        if (e.target.getAttribute('aria-disabled') !== 'true')
            return

        e.preventDefault()
        e.stopPropagation()
    }

    onControlsGroupsClearBtnsClick (e) {
        const group = this.getControlsGroups()
            .filter(el => el.contains(e.target))[0]

        if (!group)
            return

        const radios = Array
            .from(group.querySelectorAll('[type="radio"]'))

        if (radios.length)
            radios[0].checked = true

        Array.from(group.querySelectorAll('[type="checkbox"]:checked'))
            .forEach(el => {
                el.checked = false
            })

        const controls = this.getControls()
            .filter(el => el.contains(e.target))[0]

        const submitBtn = this.getSubmitButtons()
            .filter(el => controls.contains(el))[0]

        if (submitBtn) {
            const isControlsChange = this.isChange(controls)

            if (isControlsChange && submitBtn.disabled)
                submitBtn.disabled = false

            if (!isControlsChange && !submitBtn.disabled)
                submitBtn.disabled = true
        }

        this.renderControlsGroupsCtaBtns()

        if (e.target.classList.contains('focus-visible')
                && this.isElementComputedStyleVisible(
                    e.target.nextElementSibling))
            e.target.nextElementSibling.focus()
    }

    onControlsOffCanvasContentScroll (el) {
        const controls = this.getControls()
            .filter(_el => _el.contains(el))[0]

        if (!controls)
            return

        const scrollY = el.Scroller.state.get('scrollY')

        if (!scrollY && controls.getAttribute('data-scrollY'))
            return controls.removeAttribute('data-scrollY')

        if (scrollY !== controls.getAttribute('data-scrollY'))
            controls.setAttribute('data-scrollY', scrollY)
    }

    onControlsOffCanvasExpandToggleClick (e) {
        const controls = this.getControls()
            .filter(el => el.contains(e.target))[0]

        const groups = this.getControlsGroups()
            .filter(el => controls.contains(el)
                && el.querySelector('[required]:invalid'))

        if (!groups.length)
            return

        groups
            .forEach((el) => {
                const invalid = el.querySelector(
                    'fieldset [data-form-conditional-element][required]:invalid')

                if (!invalid)
                    return

                const inputs = Array.from(el.querySelectorAll('[name]'))
                    .filter(_el => _el.type === 'radio'
                        && !_el.checked)

                if (!inputs.length)
                    return

                const defaults = Array.from(el.querySelectorAll('[name]'))
                    .filter(_el => _el.value === this.params[_el.name])

                if (defaults.indexOf(inputs) >= 0)
                    return defaults.click()

                inputs[0].click()
            })
    }

    isChange (el) {
        if (!el
                || !el.className.match(/query-filters-controls(?:-group)*/))
            return

        const params = Object.assign({}, this.params)

        Object.keys(params)
            .forEach(key => {
                if (el.querySelector(`[name="${key}"]`))
                    return

                delete params[key]
            })

        const activeParams = Array.from(el
            .querySelectorAll('[name]'))
            .filter(_el => !_el.type.match(/(radio|checkbox)/i)
                || _el.checked)
            .map(el => [el.name, el.value])
            .reduce((obj, [key, value]) => {
                if (!obj[key])
                    return { ...obj, [key]: value }

                if (Array.isArray(obj[key]))
                    obj[key].push(value)

                if (!Array.isArray(obj[key]))
                    obj[key] = [obj[key], value]

                return obj
            }, {}) || {}

        let isChange = false

        try {
            isChange = JSON.stringify(params) !== JSON.stringify(activeParams)
        }
        catch (e) {
            console.warn(e)
        }

        return isChange
    }

    getNavBtns () {
        return Array.from(this.el
            .querySelectorAll('.query-filters-nav [data-expand]'))
    }

    getForm () {
        return this.props.form
            ? document.querySelector(`form#${this.props.form}`)
            : (this.el.tagName === 'FORM'
                ? this.el
                : this.el.querySelector('form'))
    }

    getControls () {
        return Array.from(this.el.querySelectorAll(
            '.query-filters-controls'))
    }

    getControlsGroups () {
        return Array.from(this.el.querySelectorAll(
            '.query-filters-controls-group'))
    }

    getControlsGroupsInputs () {
        return Array.from(this.el.querySelectorAll(
            '.query-filters-controls-group [name]'))
    }

    getControlsGroupsClearBtns () {
        return Array.from(this.el.querySelectorAll(
            '.query-filters-controls-group-cta-btn-clear'))
    }

    getControlsGroupsApplyBtns () {
        return Array.from(this.el.querySelectorAll(
            '.query-filters-controls-group-cta-btn-apply'))
    }

    getControlsOffCanvasContent () {
        return this.getControls()
            .map(el => el.querySelector('.off-canvas-content'))
            .filter(el => el)
    }

    getControlsOffCanvasExpandToggles () {
        return Array.from(this.el.querySelectorAll(
            '.query-filters-controls [data-expand]'))
    }

    getSubmitButtons () {
        return Array.from(this.el.querySelectorAll('[type=submit]'))
    }

    getQueryStringParams () {
        return window.location.search.replace(/^\?/, '')
            .split('&')
            .map(str => decodeURIComponent(str.trim())
                .split('='))
            .filter(arr => arr.length > 1)
            .reduce((obj, [key, value]) => {
                if (!obj[key])
                    return { ...obj, [key]: value }

                if (Array.isArray(obj[key]))
                    obj[key].push(value)

                if (!Array.isArray(obj[key]))
                    obj[key] = [obj[key], value]

                return obj
            }, {}) || {}
    }

    getQueryStringParamsWithDefaults () {
        const qsParams = Object.assign({}, this.paramsQueryString)

        this.getControlsGroupsInputs()
            .filter((el) => {
                if (!el.name
                        || el.name in qsParams
                        || el.type === 'checkbox')
                    return false

                if (el.type !== 'radio')
                    return el

                const inputs = Array.from(
                    this.el.querySelectorAll(`[type="radio"][name="${el.name}"]`))

                return !inputs.indexOf(el)
            })
            .forEach((el) => {
                qsParams[el.name] = el.value
            })

        return qsParams
    }

    renderControlsGroupsCtaBtns () {
        this.getControlsGroups()
            .forEach(el => {
                const isChange = this.isChange(el)

                Array.from(el
                    .querySelectorAll('.query-filters-controls-group-cta a'))
                    .forEach((_el) => {
                        const isClear = _el.classList.contains(
                            'query-filters-controls-group-cta-btn-clear')

                        const radios = Array
                            .from(el.querySelectorAll('[type=radio]'))

                        const defaultRadio = radios.length
                            ? radios[0]
                            : null

                        const checkboxes = Array
                            .from(el.querySelectorAll('[type=checkbox]'))

                        const isCheckboxChecked = el
                            .querySelector('[type="checkbox"]:checked')

                        if (isClear) {
                            if (checkboxes.length && isCheckboxChecked)
                                return _el.removeAttribute('aria-disabled')

                            if (checkboxes.length && !isCheckboxChecked)
                                return _el.setAttribute('aria-disabled', true)

                            if (radios.length
                                    && (defaultRadio.checked
                                        || isChange))
                                return _el.setAttribute('aria-disabled', true)

                            if (radios.length
                                    && defaultRadio
                                    && !defaultRadio.checked
                                    && !isChange)
                                return _el.removeAttribute('aria-disabled')
                        }

                        if (!_el.classList.contains(
                            'query-filters-controls-group-cta-btn-apply'))
                            return

                        let isInvalid = false

                        const name = el.querySelector('[name]')
                            ? el.querySelector('[name]').name
                            : null

                        const params = Object.assign({},
                            this.paramsQueryString)

                        if (radios.length
                                && defaultRadio.checked)
                            delete params[name]

                        if (radios.length
                                && !defaultRadio.checked)
                            params[name] = (this.el
                                .querySelector(`[name="${name}"]:checked`) || {})
                                .value || ''

                        if (checkboxes.length)
                            params[name] = checkboxes
                                .filter(input => input.checked)
                                .map(input => input.value)

                        Object.keys(this.params)
                            .filter(key => !(el
                                .querySelector(`[name="${key}"]`)
                                    || { type: '' }).type
                                .match(/(radio|checkbox)/))
                            .map(key => el.querySelector(`[name="${key}"]`))
                            .filter(el => el)
                            .forEach((el) => {
                                if (params[el.name] !== el.value
                                        && el.validity.valid)
                                    params[el.name] = el.value

                                if ((!el.validity.valid
                                        && !isInvalid))
                                    isInvalid = true
                            })

                        const getEncodedVal = (val) => window
                            .encodeURIComponent(val)

                        const qs = Object.keys(params)
                            .filter(key => typeof params[key] === 'string'
                                || Array.isArray(params[key]))
                            .map((key) => typeof params[key] === 'string'
                                ? `${key}=${getEncodedVal(params[key])}`
                                : params[key]
                                    .map(val => `${key}=${
                                        getEncodedVal(val)}`)
                                    .join('&'))
                            .join('&')

                        if ((!isChange || isInvalid)
                                && _el.getAttribute('href'))
                            _el.removeAttribute('href')

                        if (isChange && !isInvalid)
                            _el.setAttribute('href',
                                `${window.location.pathname}${qs
                                    ? `?${qs.replace(/&$/, '')}`
                                    : ''}`)

                        return isChange && !isInvalid
                            ? _el.removeAttribute('aria-disabled')
                            : _el.setAttribute('aria-disabled', true)
                    })
            })

        this.onResize()
    }

    render () {
        const emitChange = (input) => {
            let evt

            try {
                evt = new window.Event('change', { view: window, bubbles: true })
            }
            catch (e) {
                evt = document.createEvent('Event')
                evt.initEvent('change', true, true)
            }

            input.dispatchEvent(evt)
        }

        // Ensure input states match window.location.search on load
        Object.keys(this.params)
            .forEach((key) => {
                const value = this.params[key]

                const inputs = Array
                    .from(document.querySelectorAll(`[name="${key}"]`))

                if (!inputs.length)
                    return

                if (inputs.length === 1
                        && !inputs[0].type.match(/(select|radio|checkbox)/)
                        && inputs[0].value !== value) {
                    inputs[0].value = value
                    return emitChange(inputs[0])
                }

                if (inputs[0].type.match(/(radio|checkbox)/))
                    return inputs
                        .filter(el => {
                            if (el.type === 'radio'
                                    && el.value !== value
                                    && el.getAttribute('checked')) {
                                el.removeAttribute('checked')
                                emitChange(el)
                            }

                            return el.value === value
                                || (el.type === 'checkbox'
                                    && Array.isArray(value)
                                    && value.indexOf(el.value) >= 0)
                        })
                        .forEach(el => {
                            el.checked = true
                            emitChange(el)
                        })
            })

        Array.from(this.el.querySelectorAll('[data-query-filters-value]'))
            .filter(el => el.getAttribute('data-query-filters-value')
                && document.querySelector(`[name="${
                    el.getAttribute('data-query-filters-value')}"]`))
            .forEach(el => {
                let input = document.querySelector(`[name="${
                    el.getAttribute('data-query-filters-value')}"]`)

                const isRadioCheckbox = (input || {}).type
                    && input.type.match(/^(radio|checkbox)$/)

                if (isRadioCheckbox)
                    input = document.querySelector(`[name="${
                        el.getAttribute('data-query-filters-value')
                    }"]:checked`)

                const text = (input || {}).value
                    ? input.value
                    : (input.nextElementSibling || {}).textContent || ''

                if (!text
                        || el.innerText === text)
                    return

                const isPadNextElementSibling = el.parentElement.textContent.trim()
                    === el.nextElementSibling.textContent.trim()

                el.innerText = text

                if (isPadNextElementSibling)
                    el.nextElementSibling.innerHTML
                        = ` ${el.nextElementSibling.textContent}`
            })

        if (Object.keys(this.paramsQueryString).length)
            Array.from(this.el
                .querySelectorAll('[data-query-filters-controls-indicator]'))
                .filter(el => this.getControls()
                    .filter(_el => _el.id === el
                        .getAttribute('data-query-filters-controls-indicator'))
                    .length)
                .forEach(el => {
                    const controls = this.el
                        .querySelector(`#${el
                            .getAttribute('data-query-filters-controls-indicator')}`)

                    const active = Object.keys(this.params)
                        .filter(key => controls.querySelector(`[name="${key}"]`))
                        .map((key) => {
                            const inputs = Array
                                .from(controls.querySelectorAll(`[name="${key}"]`))

                            return (inputs[0].type === 'radio'
                                        && !inputs[0].checked)
                                    || (inputs[0].type === 'checkbox'
                                        && inputs.filter(_el => _el.checked)
                                            .length)
                                ? 1
                                : 0
                        })
                        .reduce((acc, curr) => acc + curr)

                    if (!active)
                        return

                    el.innerText = active

                    let labelSuffix = el.getAttribute(
                        'data-query-filters-controls-indicator-label-suffix')

                    if (!labelSuffix)
                        labelSuffix = 'items active'

                    el.setAttribute('aria-label', `${active} ${labelSuffix}`)
                })

        this.renderControlsGroupsCtaBtns()
    }
}
